<template>
    <!-- 处方详情 -->
    <div class="order-detail">
        <div class="order-content-box orderStatus">
            <div class="ordercode">
                <span class="top_order_code"
                    >订单号：{{
                        recipeInfo[0] && recipeInfo[0].order_code
                    }}</span
                >
                <span
                    class="cope_order_cope"
                    @click="copyUrl"
                    :data-clipboard-text="
                        recipeInfo[0] && recipeInfo[0].order_code
                    "
                    >复制</span
                >
            </div>
            <div class="info-card">
                <div class="card-header2">收货信息</div>
                <!-- <span
                    class="updateAddress"
                    v-if="useStatus == 0 || useStatus == 1"
                    @click="gotoAddressListFn"
                    >修改地址</span
                > -->
                <div
                    v-if="currentAddress.receiver_name"
                    class="address-info-content"
                >
                    <div class="left-address-info">
                        <div class="address-info-text">
                            <p class="user-info">
                                <label class="order-detail-label"> 收货人</label
                                >：
                                <span class="left-detail">
                                    {{ currentAddress.receiver_name }}
                                    {{ currentAddress.receiver_phone }}
                                </span>
                            </p>
                            <p class="user-address">
                                <label class="order-detail-label">地址</label>：
                                <span class="left-detail">
                                    {{ currentAddress.receiver_province }}
                                    {{ currentAddress.receiver_city }}
                                    {{ currentAddress.receiver_area }}
                                    {{ currentAddress.receiver_address }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="info-card">
                <div class="doctor-name-box">
                    <div>
                        <!-- <span class="order-detail-title-icon"></span> -->
                        <span class="card-header1"> 服务医师</span>：{{
                            recipeInfo[0] && recipeInfo[0].doctorInfo.name
                        }}
                    </div>
                    <div>
                        <!-- <span class="order-detail-title-icon"></span> -->
                        <span class="card-header1"> 诊断</span>：{{
                            recipeInfo[0] &&
                            recipeInfo[0].disease_differentiation
                        }}
                    </div>
                    <!-- <div class="disease-differentiation-box">
            诊断：{{ recipeInfo[0] && recipeInfo[0].disease_differentiation }}
          </div> -->
                </div>
            </div>
            <!-- 就诊信息 -->
            <!-- <div class="info-card">
        <div class="card-header">就诊信息</div>
        <ul class="list-info-box">
          <li class="list-info-item">
            <div class="list-info-title">患者</div>
            <div class="user-info-text">{{recipeInfo.name}} {{recipeInfo.sex}} <span v-if="recipeInfo.age">{{recipeInfo.age}}岁</span></div>
          </li>
          <li class="list-info-item">
            <div class="list-info-title">本次诊断</div>
            <div class="user-info-text">{{recipeInfo.diagnoseStr}}</div>
          </li>
        </ul>
      </div> -->
            <!-- 药品信息 -->
            <div class="info-card lastinfocardbottom">
                <div class="card-header">
                    处方
                    <div
                        class="presciption-btn"
                        @click="toPrescription"
                        v-show="prescriptionRaft" v-if="recipeInfo[0].useStatus ==2||useStatus ==3 ||useStatus ==4"
                    >
                        处方笺
                    </div>
                </div>
                <!-- <div class="order-info-item" @click="toPrescription">
          <div>
            <img src="../assets/images/orderIcon.png" class="order-icon">
            <span class="order-name">处方笺</span>
          </div>
          <div>></div>
        </div> -->
                <div v-for="(item, index) in recipeInfo" :key="index">
                    <div class="recipeInfo">
                        <img
                            class="recipeInfo_img"
                            :src="item.company_url"
                            alt=""
                        />
                        <span class="recipeInfo_company_name"
                            >{{ item.company_name }}
                            <span v-if="item.drug_type != 5 &&item.drug_type != 6"> - </span>
                            <span v-if="item.drug_type == 1">颗粒剂</span>
                            <span v-if="item.drug_type == 2">西药/中成药</span>
                            <span v-if="item.drug_type == 3">西药/中成药</span>
                            <span v-if="item.drug_type == 4">饮片</span>
                            <span v-if="item.drug_type == 5">针刀</span>
                            <span v-if="item.drug_type == 6"> </span>

                        </span>
                    </div>
                    <ul
                        v-if="item.drug_type == 1 || item.drug_type == 4"
                        :class="{
                            'drug-info-list':
                                item.drug_type == 1 || item.drug_type == 4,
                        }"
                    >
                        <!-- 1 颗粒剂 2 西药 3 中成药  4 饮片 -->
                        <li
                            v-for="(item1, index) in item.drugList"
                            :key="index"
                            class="drug-info-item"
                        >
                            <span class="drug-name">{{ item1.drugName }}</span>

                            <span
                                class="drug-price"
                                v-show="showtoPrescription"
                            >
                                {{ item1.actualSpecification }}</span
                            >
                             <span
                                class="drug-price" v-if="item.drug_type == 6"
                            >
                                {{ item1.actualSpecification }}</span
                            >
                        </li>
                        <!-- oral_administration  1-内服/0-外用  99-未传参数/98-无意义 -->
                        <div class="drug-dosage" v-show="showtoPrescription">
                            共<span class="agent">{{ item.agent_sum }}</span
                            >剂，每日{{ item.day_agent }}剂，1剂分<span
                                class="agent"
                            >
                                {{ item.agent_count }}</span
                            >次
                        </div>
                        <div
                            class="take"
                            v-show="showtoPrescription"
                            v-if="
                                item.drug_type == 1 &&
                                item.oral_administration != 99
                            "
                        >
                            <div>
                                服用方式:
                                <div class="mode">
                                    <span v-if="item.oral_administration == 98"
                                        >无意义</span
                                    >
                                    <span v-if="item.oral_administration == 1"
                                        >内服</span
                                    >
                                    <span v-if="item.oral_administration == 0"
                                        >外用</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div
                            class="take4"
                            v-show="showtoPrescription"
                            v-if="
                                item.drug_type == 4 &&
                                item.oral_administration != 99
                            "
                        >
                            <div class="oral_administration">
                                <span v-if="item.oral_administration == 98"
                                    >无意义</span
                                >
                                <span v-if="item.oral_administration == 1"
                                    >内服</span
                                >
                                <span v-if="item.oral_administration == 0"
                                    >外用</span
                                >
                            </div>
                            <span
                                class="decocting"
                                v-if="item.is_decocting == 0"
                                >不代煎</span
                            ><span
                                class="decocting"
                                v-if="item.is_decocting == 1"
                                >代煎</span
                            >
                        </div>

                        <div class="drug_box"></div>
                    </ul>
                    <ul
                        v-if="item.drug_type == 2 || item.drug_type == 3 || item.drug_type == 6"
                        :class="{
                            'drug-info-list1':
                                item.drug_type == 2 || item.drug_type == 3 || item.drug_type == 6,
                        }"
                    >
                        <!-- 1 颗粒剂 2 西药/中成药 3 西药/中成药  4 饮片 -->
                        <li
                            v-for="(item1, index) in item.drugList"
                            :key="index"
                            class="drug-info-item"
                        >
                            <div class="drug_content" style="font-size: 16px">
                                <span class="name">药品</span>：<span
                                    class="drug-name"
                                    >{{ item1.drugName }}</span
                                >

                                <span
                                    class="drug-price"
                                    style="font-size: 16px"
                                    v-show="showtoPrescription"
                                >
                                    {{ item1.actualSpecification }}</span
                                >
                                  <span
                                    class="drug-price"
                                    style="font-size: 16px" v-if="item.drug_type == 6"
                                >
                                    {{ item1.actualSpecification }}</span
                                >
                                
                            </div>
                            <div class="drug_content" style="font-size: 16px">
                                <span class="name">用法用量</span>：<span
                                    class="drug-name1"
                                    >{{ item1.medication_time }}</span
                                >
                            </div>
                            <div class="drug_content1" style="font-size: 16px">
                                <span class="name">补充说明</span>：<span
                                    class="drug-name"
                                    >{{ item1.other }}</span
                                >
                            </div>
                        </li>
                        <div class="drug_box"></div>
                    </ul>
                    <ul
                        v-if="item.drug_type == 5"
                        :class="{
                            'drug-info-list1':
                                item.drug_type == 2 ||
                                item.drug_type == 3 ||
                                item.drug_type == 5 || item.drug_type == 6,
                        }"
                    >
                        <!-- 1 颗粒剂 2 西药/中成药 3 西药/中成药  4 饮片 -->
                        <li
                            v-for="(item1, index) in item.drugList"
                            :key="index"
                            class="drug-info-item"
                        >
                            <div class="drug_content" style="font-size: 16px">
                                <span class="name">针刀治疗</span>：<span
                                    class="drug-name"
                                    >{{ item1.needle_knife_name }}</span
                                >
                            </div>
                        </li>
                        <div class="drug_box"></div>
                    </ul>
                </div>
            </div>

            <!-- 订单信息 -->
            <div class="info-card">
                <div class="list-info-box">
                    <div>费用合计</div>
                    <div>￥{{ totalPrice | thousandCharacter }}</div>
                   
                </div>
            </div>
        </div>
        <!-- 底部提交按钮 -->
        <div
            class="bottom-info-box"
            v-if="recipeInfo.length && (useStatus == 8 || useStatus == 1)"
        >
            <!-- 提交按钮 -->
            <div class="bottom-info-box-content">
                <!-- <span class="bottom-info-count">共{{drugList.length}}件</span>
        <label class="bottom-info-price">
          合计：<span class="bottom-info-price-num">￥{{totalPrice}}</span>
        </label> -->
                <van-button class="bottom-submit-btn" @click="examine">
                    {{ useStatus == 8 ? '提交订单' : '去支付' }}</van-button
                >
            </div>
        </div>
        <!-- 底部状态按钮 -->
        <div v-else-if="useStatus == 3 || useStatus == 4">
            <div class="bottom-info-box">
                <div class="bottom-status-box">
                    <van-button class="bottom-submit-btn" @click="checkExpress"
                        >查看物流信息</van-button
                    >
                </div>
            </div>
        </div>

        <!-- dialog组件调用 有物流单号显示 -->
        <van-popup
            v-model="dialogShow"
            closeable
            close-icon="close"
            :style="{ width: '80%' }"
        >
            <div class="title">物流信息</div>
            <div
                v-for="(item, index) in expressNumberList"
                :key="index"
                class="express-info"
            >
                <div v-if="item.expressNumber" class="express-info-recipeType">
                    {{ item.recipeType }}
                </div>
                <div style="width: 100%" class="express-info-child">
                    <div
                        v-if="item.expressNumber"
                        class="expressNumber"
                        style="width: 80%"
                    >
                        <span>{{ item.expressName }}：</span
                        ><span class="getexpressNumber">{{
                            item.expressNumber
                        }}</span>
                    </div>
                    <van-button
                        @click="BtnExpress(item)"
                        v-if="item.expressNumber"
                        class="expressBtn"
                        type="info"
                        >查询</van-button
                    >
                </div>
            </div>
        </van-popup>

        <!-- 无物流单号显示 -->
        <van-popup
            v-model="dialogNoShow"
            closeable
            close-icon="close"
            :style="{ width: '80%' }"
        >
            <div class="title">物流信息</div>
            <div class="expressNumbernoshow">暂无物流信息</div>
        </van-popup>
    </div>
</template>

<script>
/* eslint-disable */
// import qs from 'qs';
// import wx from 'weixin-js-sdk';
import { Toast as VanToast, Dialog, Button, Popup as VanPopup } from 'vant';
import address from '../services/address';
import areaList from '../lib/area';
import axios from '../services/recipe';
import Clipboard from 'clipboard';
import { Toast } from 'vant';

export default {
    name: 'OrderDetail',
    data() {
        return {
            // 处方信息
            sameBatch: '',
            showtoPrescription: false,
            prescriptionRaft: false,
            recipeInfo: [],
            drugList: [],
            expressPrice: 0,
            price: 0,
            totalPrice: 0,
            // 订单状态
            orderStatus: '',
            currentAddress: '',
            expressNumber: '',
            expressInfo: [],
            expressNumberArr: [],
            dialogShow: false, // 有物流
            dialogNoShow: false, // 暂无物流信息
            showConfirmButton: false, // 确认按钮
            expressNumberList: [],
            flag: false,

        };
    },
    components: {
        [Dialog.Component.name]: Dialog.Component,
        Button,
        Toast,
        VanPopup,
    },
    computed: {
        useStatus() {
            return (this.recipeInfo[0] || {}).useStatus;
        },
    },
    mounted() {
        this.areaList = areaList;

        console.log(this.$route);
        this.getPrescriptionInfo();
        if (this.$route.query.addressId > 0) {
            this.getAddressInfo(this.$route.query.addressId);
        }
    },
    methods: {
        // 复制文本
        copyUrl() {
            let clipboard = new Clipboard('.cope_order_cope'); // 这里括号里填写上面点击事件绑定的class名
            clipboard.on('success', (e) => {
                // 复制成功，提示根据自己项目实际使用的UI来写
                Toast.success('复制成功');
                // 释放内存

                clipboard.destroy();
            });
            clipboard.on('error', (e) => {
                // 不支持复制，提示根据自己项目实际使用的UI来写
                Toast.fail('复制失败，该浏览器不支持自动复制');

                // 释放内存
                clipboard.destroy();
            });
        },
        toPrescription() {
            this.$router.push({
                path: `/prescription/${this.$route.params.id}`,
            });
        },
     
        getAddressInfo(id) {
      
            // 获取用户收货地址详情
            address
                .getUserAddressById({
                    patient_id: this.$store.getters.getUserInfo.patientId,
                    id,
                })
                .then((res) => {
                    const data = res.data.data;
                    const _item = {};
                    _item.receiver_name = data.receiver_name;
                    _item.receiver_phone = data.receiver_phone;
                    _item.receiver_address =
                        this.areaList.province_list[data.receiver_province] +
                        this.areaList.city_list[data.receiver_city] +
                        this.areaList.county_list[data.receiver_area] +
                        data.receiver_address;
                    _item.id = data.id;
                    this.currentAddress = _item;
                    console.log(_item);
                })
                .catch(() => {});
        },
        // 获取处方笺信息
        getPrescriptionInfo() {
            const params = {
                recipeId: this.$route.params.id,
            };
            axios.getRecipeInfo(params).then((res) => {
                this.expressorderCode = res.data.data.data[0].order_code;
                this.sameBatch = res.data.data.data[0].sameBatch;

                if (
                    res.data.data.status &&
                    res.data.data.status === 'success'
                ) {
                    this.recipeInfo =
                        res.data.data.data instanceof Array
                            ? res.data.data.data
                            : [res.data.data.data];
                    this.price = res.data.data.price || 0;

                    this.totalPrice = res.data.data.totalPrice || 0;
                    this.recipeInfo.forEach((info) => {
                        if (info.diagnose) {
                            const diagnoseStr = info.diagnose.join('，');
                            info.diagnoseStr = diagnoseStr;
                        }
                        if (info.gender == 1) {
                            info.sex = '男';
                        } else if (info.gender == 2) {
                            info.sex = '女';
                        } else {
                            info.sex = '';
                        }
                        if (info.expressPrice) {
                            this.expressPrice += Number(
                                info.expressPrice.replace(/,/g, '')
                            );
                        }
                    });
                    var NumuseStatys = parseInt(this.useStatus);

                    // data_hide：是否隐藏药品数据中的克数(0:隐藏 / 1:显示 / 99:未传参数)
                    let status = [2, 3, 4];
                    if (status.includes(NumuseStatys) && this.recipeInfo[0].data_hide != 0) {
                        this.showtoPrescription = true;
                    }
                    let tempList = this.recipeInfo.filter(item => item.drug_type == 5);
                    this.prescriptionRaft = !(tempList.length == this.recipeInfo.length);
                }
            });
        },
    examine(){

axios.getExamine(this.recipeInfo[0].orderNum ).then((res)=>{
console.log(res)
if(res.data.code ==200){
    this.submitOrderFn()
}else{
 VanToast.fail(res.data.msg+"请稍后再试");

}
})
    },
        submitOrderFn() {
            if (this.useStatus == 1) {
                this.$router.push({
                    path: '/pay',
                    query: {
                        orderNum: this.recipeInfo[0].orderNum,
                        price: this.totalPrice,
                    },
                });
            } else {
                const params = {
                    recipeId: this.$route.params.id,
                    addressId: this.$route.query.addressId,
                };
                console.log('提交订单', params);
                axios.submitPayOrder(params).then((res) => {
                    if (res.data.status === 'success') {
                        VanToast.success('订单生成成功');
                        if (res.data.data.orderNum) {
                            this.$router.push({
                                path: '/pay',
                                query: {
                                    orderNum: res.data.data.orderNum,
                                    price: this.totalPrice,
                                },
                            });
                        }
                    } else {
                        VanToast.fail('服务异常，请稍后再试');
                    }
                });
            }
        },

        // checkExpress() {
        //   this.$router.push({
        //     name: 'logistics',
        //   });
        // },

        //  物流信息按钮
        // checkExpress() {
        //   const params = {
        //     recipeId: this.$route.params.id,
        //   };
        //   axios
        //     .getRecipeInfo(params)
        //     .then((res) => {
        //       console.log(res);
        //       console.log('处方详情数据请求');
        //       this.expressInfo = res.data.data;
        //       this.expressInfo.forEach((item) => {
        //         this.expressNumber = item.expressNumber;
        //         console.log(this.expressNumber);
        //         // this.expressNumberArr.push(this.expressNumber) // 把处方详情运单号添加到数组里
        //         // let arr1 = this.expressNumber.text.split(',');
        //         // console.log(arr1);
        //         // sessionStorage.setItem('expressNumber', this.expressNumber);
        //       });
        //       console.log(this.expressNumber);
        //       // console.log(expressNumberArr);
        //       this.$router.push({
        //         name: 'logistics',
        //         params: {
        //           // expressNumber: this.expressNumber,
        //           expressNumber: 'SF1300713620214',
        //         },
        //       });
        //     })
        //     .catch(() => {});
        // },

        // 查看物流信息
        // 查看物流信息
        checkExpress() {
            const params = {
                sameBatch: this.sameBatch,
            };
            console.log(params);
            axios
                .getQueryExpress(params)

                .then((res) => {
                    this.expressNumberList = res.data.data;

                    console.log(this.expressNumberList);
                    if (this.expressNumberList == undefined) {
                        this.flag = false;
                    } else {
                        this.flag = true;
                    }
                    if (this.flag) {
                        this.dialogShow = true; // 显示物流
                    } else {
                        this.dialogNoShow = true; // 显示暂无物流信息
                    }
                });
        },

        // 查看物流详情
        BtnExpress(item) {
            console.log(item);
            var getexpressNumber = item.expressNumber;
            // console.log(getexpressNumber);
            this.expressNumber = getexpressNumber;
            console.log(this.expressNumber);
            this.$router.push({
                name: 'logistics',
                params: {
                    expressNumber: this.expressNumber,
                    // expressNumber: 'SF1300713620214',
                },
            });
        },
    },
    filters: {
        thousandCharacter(value) {
            if (value instanceof String) {
                return value;
            }
            return (value || 0)
                .toString()
                .replace(/\d{1,3}(?=(\d{3})+[.$])/g, '$&,');
        },
    },
};
</script>
<style lang="less" scoped>
.take {
    padding: 20px 0px 0 0;
    font-size: 16px;
    .mode {
        display: inline-block;
        width: 66px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: rgba(24, 163, 112, 1);
        color: #fff;
        border-radius: 4px;
        margin-left: 15px;
    }
}
.take4 {
    padding: 20px 0px 0 0;
    font-size: 16px;

    .oral_administration {
        display: inline-block;
        width: 66px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: rgba(24, 163, 112, 1);
        color: #fff;
        border-radius: 4px;
        margin-right: 15px;
    }
    .decocting {
        display: inline-block;
        width: 66px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: rgba(24, 163, 112, 1);
        color: #fff;
        border-radius: 4px;
    }
}
.order-detail {
    min-height: 100vh;
    background-color: #f7f7f7;
    overflow-y: auto;
    .ordercode {
        width: 100%;
        background-color: #fff;
        border-bottom: 5px solid #f7f7f7;
        padding: 20px 15px;
        position: relative;
    }
    .top_order_code {
        font-size: 14px;

        font-weight: 400;
        color: #333333;
        line-height: 14px;
    }
    .cope_order_cope {
        position: absolute;
        font-size: 14px;
        padding: 2px 7px;

        border-radius: 4px;
        background: #208fe3;
        font-weight: 500;
        color: #ffffff;
        right: 15px;
        top: 18px;
    }
    .order-status-box {
        color: #fff;
        .order-status-title {
            font-size: 18px;
            margin-bottom: 12px;
        }
        .order-status-description {
            font-size: 14px;
            margin-bottom: 20px;
        }
    }
    .order-content-box.order-status {
        background: no-repeat top / contain
            url('../assets/images/orderBackground.png');
    }
}
.info-card {
    background: #ffffff;
    border-bottom: 5px solid #f7f7f7;
    // padding: 15px;
    // margin-bottom: 15px;
    &:last-child {
        border: none;
    }
    .list-info-box {
        padding: 0 15px;
        height: 54px;
        font-size: 16px;
        color: #333;
        line-height: 54px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 80px;
    }
    .order-detail-title-icon {
        display: inline-block;
        width: 2px;
        height: 10px;
        background: #208fe3;
    }
    .card-header1 {
        display: inline-block;
        font-size: 16px;
        color: #333;
        width: 67px;
        text-align-last: justify;
        padding: 0 0 10px 0;
        position: relative;
    }
    .card-header2 {
        display: inline-block;
        font-size: 16px;
        color: #333;
        font-weight: bold;
        padding: 20px 0px 15px 15px;
    }
    .updateAddress {
        position: absolute;
        right: 15px;
        font-size: 14px;
        padding: 2px 7px;
        margin-top: 18px;
        border-radius: 4px;
        background: #208fe3;
        font-weight: 500;
        color: #ffffff;
    }
    .card-header {
        // height: 30px;
        // border-bottom: 1px solid #ebebeb;
        font-size: 18px;
        color: #333;
        font-weight: bold;
        padding: 20px 0px 0px 15px;
        position: relative;
        .presciption-btn {
            position: absolute;
            right: 15px;
            top: 18px;
            z-index: 9;
            background: #208fe3;
            color: #fff;
            padding: 2px 6px;
            font-size: 14px;

            border-radius: 4px;
        }
    }
    .doctor-name-box {
        padding: 20px 15px 10px 15px;
        font-size: 16px;
    }
    .disease-differentiation-box {
        font-size: 14px;
        color: #208fe3;
        max-width: 50vw;
    }
    .no-name {
        font-size: 13px;
        color: #999;
        float: right;
        position: relative;
        top: 6px;
        right: 10px;
    }
    .no-name-img {
        width: 16px;
        height: 16px;
        float: right;
        position: relative;
        top: 4px;
        right: 0;
    }
    // .list-info-item {
    //   height: 30px;
    //   line-height: 30px;
    //   // margin-top: 10px;
    //   display: flex;
    //   justify-content: space-between;
    //   .list-info-title {
    //     min-width: 70px;
    //   }
    //   .user-info-text {
    //     width: 70%;
    //     overflow: hidden;
    //     text-overflow: ellipsis;
    //     white-space: nowrap;
    //     text-align: right;
    //   }
    // }
    .address-info-content {
        display: flex;
        justify-content: space-between;
        .left-address-info {
            display: flex;
        }
        .address-icon {
            width: 30px;
            height: 30px;
            vertical-align: middle;
        }

        .address-info-text {
            display: inline-block;
            margin-left: 15px;
            vertical-align: middle;
            .user-address {
                font-size: 14px;
                color: #4d4d4d;
                margin-bottom: 20px;
            }
        }
        .right-arrow-icon {
            width: 16px;
            height: 16px;
            margin-top: 12px;
        }
    }
    .user-info,
    .user-address {
        margin-bottom: 7px;
        font-size: 14px;
        color: #4d4d4d;
        display: flex;
        font-size: 16px;
        .order-detail-label {
            display: inline-block;
            min-width: 67px;
            color: #333;
            text-align: justify;
            height: 20px;
            &::after {
                content: '';
                display: inline-block;
                width: 100%;
                overflow: hidden;
                height: 0;
            }
        }
        .left-detail {
            color: #595959;
        }
    }
    .right-arrow-icon {
        width: 16px;
        height: 16px;
        vertical-align: middle;
    }
    .order-info-item {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        .order-icon {
            width: 18px;
            height: 21px;
            vertical-align: middle;
        }
        .order-name {
            font-size: 16px;
            margin-left: 6px;
            vertical-align: middle;
        }
        .right-arrow-icon {
            margin: 0;
        }
    }
    .drug-dosage {
        color: #595959;
        font-size: 16px;
        .agent {
            display: inline-block;
            text-align: center;
            border-bottom: 1px solid #999;
            width: 50px;
            color: #18a370;
            font-weight: 500;
        }
    }
    .drug-info-list1 {
        .drug-name1 {
            width: 80%;
        }

        .drug_content {
            padding: 0 15px 10px 15px;
        }
        .drug_content1 {
            padding: 0 15px 15px 15px;
        }
        .name {
            display: inline-block;
            width: 70px;
            text-align-last: justify;
            font-style: 16px;
        }
        .drug_box {
            border-bottom: 1px solid rgba(229, 229, 229, 0.5);
            // margin-bottom: 20px;
            margin: 0 15px;
            // margin-top: 10px;
        }
    }
    .drug-info-list {
        padding: 0 15px 0px 15px;

        .drug_box {
            border-bottom: 1px solid rgba(229, 229, 229, 0.5);
            // margin-bottom: 20px;
            margin-top: 20px;
        }

        .drug-info-item {
            display: inline-block;
            margin-bottom: 10px;
            width: 50%;
            font-size: 16px;

            .drug-name {
                color: #4d4d4d;
                line-height: 21px;
            }
            .drug-price {
                color: #4d4d4d;
                margin-left: 5px;
            }
        }
        .chinese-medicine {
            width: 45vw;
            display: inline-block;
        }
    }
    .name {
        display: inline-block;
        width: 70px;
        text-align-last: justify;
    }

    .pay-type {
        font-size: 16px;
        color: #30b972;
        vertical-align: middle;
        margin-right: 3px;
    }
    .no-address-card {
        display: flex;
        flex-direction: row;
        height: 60px;
        line-height: 74px;
        justify-content: space-between;
        .left-section {
            display: flex;
        }
        .no-card-icon {
            width: 30px;
            height: 30px;
            margin-top: 21px;
            margin-right: 10px;
        }
        .no-card-tip {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #bbbbbb;
            letter-spacing: 0;
        }
        .add-address-btn {
            width: 16px;
            height: 16px;
            margin-top: 30px;
        }
    }
}
.pay-pop-box {
    .pay-pop-list {
        border-bottom: 7px solid #eee;
        .pay-pop-item {
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 18px;
            color: #333;
            border-bottom: 1px solid #ddd;
        }
    }
    .pay-pop-cancel {
        width: 100%;
        height: 80px;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
        color: #333;
        border-top: 1px solid #ddd;
    }
}
.service-btn-box {
    margin-bottom: 50px;
    text-align: center;
    font-size: 16px;
    color: #30b972;
    .service-icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        width: 18px;
        height: 18px;
        background: no-repeat center/contain
            url('../assets/images/serviceIcon.png');
    }
    .service-btn {
        display: inline-block;
        vertical-align: middle;
    }
}
.bottom-info-box {
    width: 100%;
    height: 64px;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    border-top: 1px solid #ebebeb;
    .bottom-info-box-content {
    }
    .bottom-info-count {
        font-size: 14px;
        color: #999;
        margin-right: 10px;
    }
    .bottom-info-price {
        font-size: 16px;
        color: #333;
        margin-right: 10px;
        .bottom-info-price-num {
            color: #e64340;
            font-weight: bold;
        }
    }
    .bottom-submit-btn {
        width: 90%;
        height: 44px;
        background: #208fe3;
        border-radius: 4px;
        position: absolute;
        left: 5%;
        top: 10px;
        color: white;
    }
    .bottom-no-drug-btn {
        background: #bbb;
    }
    .bottom-status-box {
        background: #f7f7f7;
        // padding: 15px;
        text-align: center;
        .bottom-submit-btn {
            font-size: 18px;

            background: #208fe3;

            // border: 1px solid #30b972;
        }
        .bottom-no-drug-btn {
            background: #bbb;
        }
    }
}

/deep/.van-overlay {
    background-color: rgba(0, 0, 0, 0.7);
    // background-color: red;
}

/deep/.van-dialog__content {
    padding: 15px 0;
}

.van-dialog {
    padding: 0px 15px;
}
/deep/.van-dialog__header {
    font-size: 20px;
    color: #333333;
    // padding-top: 10px;
}
.express-no {
    text-align: center;
    color: #333333;
}
.recipeInfo {
    width: 100%;
    padding: 20px 0 10px 15px;
    position: relative;
    .recipeInfo_img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
    }

    .recipeInfo_company_name {
        position: absolute;
        left: 48px;
        top: 25px;
        font-weight: bold;
        color: #333333;
        font-size: 16px;
    }
}
.van-popup {
    border-radius: 8px;
    .title {
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        line-height: 18px;
        width: 100%;
        text-align: center;
        padding: 20px 0;
    }
    .express-info {
        padding: 0 15px;
        padding-bottom: 2px;
        font-size: 14px;
        color: #333333;

        .express-info-recipeType {
            font-size: 16px;
            margin-bottom: 10px;

            font-weight: 500;
        }
    }
    .express-info-child {
        position: relative;
        padding-bottom: 15px;
        margin-bottom: 15px;
        border-bottom: 1px solid #e3e3e3;
        .expressNumber {
            font-style: 16px;
        }
        .expressBtn {
            position: absolute;
            top: 0;
            right: 0px;
            padding: 0;
            display: inline-block;
            border-radius: 4px;
            background-color: #208fe3;
            // height: 100%;
            height: 22px;
            width: 44px;
        }
    }
    .expressNumbernoshow {
        text-align: center;
        padding-bottom: 20px;
        font-size: 16px;
    }
  
}
  .expressPrice{
        font-size: 14px;
    }
</style>
